import React from 'react';
import { WifiOff, Wifi, AlertTriangle } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { Alert, AlertDescription } from '@/components/ui/alert';

const NetworkStatusIndicator: React.FC = () => {
  const { isOnline, isSlowConnection } = useNetworkStatus();

  if (isOnline && !isSlowConnection) {
    return null; // Don't show anything when connection is good
  }

  if (!isOnline) {
    return (
      <div className="fixed top-20 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-sm">
        <Alert className="border-destructive bg-destructive/10">
          <WifiOff className="h-4 w-4 text-destructive" />
          <AlertDescription className="text-destructive font-medium">
            Sem conexão com a internet. Algumas funcionalidades podem estar limitadas.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  if (isSlowConnection) {
    return (
      <div className="fixed top-20 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-sm">
        <Alert className="border-yellow-500 bg-yellow-50">
          <AlertTriangle className="h-4 w-4 text-yellow-600" />
          <AlertDescription className="text-yellow-700 font-medium">
            Conexão lenta detectada. O carregamento pode ser mais demorado.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return null;
};

export default NetworkStatusIndicator;